import React from 'react';
import { Image } from 'rebass/styled-components';
import Icon from '../../../../assets/icon-linkedin-small.svg';

export const LinkedInIcon = () => <Image src={Icon} alt="LinkedIn" width="16px" height="16px" />;
